import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { PiEyeFill } from "react-icons/pi";
import { PiEyeSlashFill } from "react-icons/pi";
import { PiUserFill } from "react-icons/pi";
import { MdLockReset } from "react-icons/md";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import UseLambdaInvocations from '../../hooks/useLambdaInvocations';
import lambdaConfig from '../../hooks/lambdaConfig';
import { configData } from "../../config/systemconfigurationconstants";
import { ToastContainer, toast } from "react-toastify";
const ResetPassword = ({ show, handleClose }) => {
  const { invokeLambda, loading, error } = UseLambdaInvocations();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState('');
  const [resetinputType, setResetinputType] = useState('password');
  const [resetconfirmpwdinputType, setResetconfirmpwdinputType] = useState('password');
  //Reset Password Validation Begin
  const toggleResetnputType = () => {
    setResetinputType((prevType) => (prevType === 'password' ? 'text' : 'password'));
  };
  const toggleConfirmpwdnputType = () => {
    setResetconfirmpwdinputType((prevType) => (prevType === 'password' ? 'text' : 'password'));
  };
  // const handleShowResetPassword = () => setShowResetPassword(true);
  const handleCloseResetPassword = () => {
    clearForm();
    handleClose();
  }
  const clearForm = () => {
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('test')
    // Reset errors
    setErrors({});

    // Validate form inputs
    let formErrors = {};
    const specialCharacterRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}$/;


    if (!newPassword) {
      formErrors.newPassword = 'Password is required';
    } else {
      // Check for password length
      if (newPassword.length < 8) {
        formErrors.passwordLength = 'Password must have at least: 8 characters.';
      }

      // Check for complex password pattern (lowercase, uppercase, number, special char)
      if (!specialCharacterRegex.test(newPassword)) {
        formErrors.passwordComplexity = 'Password must have at least: 8 characters, one special character, one number, one uppercase and one lowercase characters.';
      }
    }

    if (!confirmPassword) {
      formErrors.confirmPassword = 'Please confirm your password';
    } else {
      // Check if passwords match
      if (newPassword !== confirmPassword) {
        formErrors.passwordMatch = 'Password and Confirm Password must be the same.';
      }
    }




    // If errors exist, stop form submission
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    try {
      // Create a copy of lambdaConfig and update the SecurityToken
      const updatedLambdaConfig = {
        ...lambdaConfig,
        SecurityToken: null, // Replace with the new SecurityToken value
      };
      const parsedBody = await invokeLambda(configData.RESET_PASSWORD, {
        ...updatedLambdaConfig,
        "UserName": localStorage.getItem('UserName'),
        "Password": newPassword,
      });
      // if (Array.isArray(parsedBody.Output.impdata)) {
      if (parsedBody.Status) {
        toast.success('Your Password has been changed successfully.', {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored"
        });
        handleCloseResetPassword();
      } else {
        toast.error('Your Password Reset has been failed!', {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored"
        });
      }
    } catch (err) {
      // Handle error if needed
    }

    // const data = {
    //   "Command": "RESET_PASSWORD",
    //   "SecurityId": "",
    //   "SecurityToken": "",
    //   "EventContextId": "",
    //   "CallerSourceId": "",
    //   "CallerSourceName": "",
    //   "UserName": localStorage.getItem('UserName'),
    //   "Password": newPassword,
    // };
    // const params = {
    //   FunctionName: configData.LAMBDA_FUNCTION_NAME,
    //   Payload: JSON.stringify(data)
    // };

    // lambda.invoke(params, (err, data) => {
    //   if (err) {
    //     console.log(err, err.stack);
    //   } else {
    //     let lambdaResponse = JSON.parse(data.Payload.toString());
    //     lambdaResponse = JSON.parse(lambdaResponse.body);
    //     let responseOutput = JSON.parse(lambdaResponse.Output);
    //     console.log(responseOutput)
    //     if (responseOutput.Status == true) {
    //       toast.success('Your Password has been changed successfully.', {
    //         position: "bottom-center",
    //         autoClose: 5000,
    //         hideProgressBar: true,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored"
    //       });
    //       handleCloseResetPassword();
    //     }
    //     else {
    //       toast.error('Your Password Reset has been failed!', {
    //         position: "bottom-center",
    //         autoClose: 2000,
    //         hideProgressBar: true,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored"
    //       });
    //     }

    //   }
    // });


  };
  //Reset Password Validation End
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>

            <InputGroup size="sm" className="mb-3">
              <InputGroup.Text id="basic-addon1"><PiUserFill />
              </InputGroup.Text>
              <Form.Control
                placeholder="Username"
                aria-label="Username"
                value={localStorage.getItem('UserName')}
                disabled />
            </InputGroup>
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-sm">
                {resetinputType === 'password' ? <PiEyeSlashFill onClick={toggleResetnputType} style={{ fontSize: '14px' }} /> : <PiEyeFill style={{ fontSize: '14px' }} onClick={toggleResetnputType} />}
              </InputGroup.Text>
              <Form.Control
                type={resetinputType}
                placeholder="New password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                isInvalid={!!errors.newPassword}

              />
              <Form.Control.Feedback type="invalid">
                {errors.newPassword}
              </Form.Control.Feedback>

            </InputGroup>



            <InputGroup size="sm" className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-sm">
                {resetconfirmpwdinputType === 'password' ? <PiEyeSlashFill onClick={toggleConfirmpwdnputType} style={{ fontSize: '14px' }} /> : <PiEyeFill style={{ fontSize: '14px' }} onClick={toggleConfirmpwdnputType} />}
              </InputGroup.Text>
              <Form.Control
                type={resetconfirmpwdinputType}
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                isInvalid={!!errors.confirmPassword || !!errors.passwordMatch || !!errors.passwordLength || !!errors.passwordComplexity}
              />
              <Form.Control.Feedback type="invalid">
                {errors.confirmPassword || errors.passwordMatch || errors.passwordLength || errors.passwordComplexity}
              </Form.Control.Feedback>
            </InputGroup>

            <Modal.Footer>
              <Button variant="secondary" size="sm" onClick={handleCloseResetPassword}>
                Cancel
              </Button>
              <Button variant="primary" type="submit" size="sm">
                Reset Password
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <ToastContainer />

    </>
  );
};

export default ResetPassword;